<template>
  <div>
    <button
      v-if="ruleId == 0 && canUserEdit"
      v-b-modal="
        'bulkEditCopyRule' +
          uniqueIdentifier +
          ruleId +
          (ruleGroup ? 'Grouped' : '')
      "
      v-b-tooltip.hover
      class="btn btn-primary mr-1"
      placement="bottom"
      title="Ausgewählte Regeln bearbeiten oder duplizieren"
      type="button"
      @click="
        ruleToEdit = ruleId;
        init();
        expandPopup = true;
      "
    >
      <i class="fas fa-copy" />
    </button>
    <b-modal
      v-if="ruleToEdit || newRule"
      :id="
        'bulkEditCopyRule' +
          uniqueIdentifier +
          ruleId +
          (ruleGroup ? 'Grouped' : '')
      "
      :ref="
        'bulkEditCopyRule' +
          uniqueIdentifier +
          ruleId +
          (ruleGroup ? 'Grouped' : '')
      "
      :title="
        'Regeln bearbeiten oder duplizieren (' +
          selectedRules.length +
          ' ausgewählt)'
      "
      hide-footer
      no-fade
      size="xl"
    >
      <div
        class="w-100"
        style="height: 24px"
      >
        <button
          v-b-tooltip.hover
          :title="expandPopup ? 'minimieren' : 'maximieren'"
          class="float-right"
          placement="bottom"
          type="button"
          @click="expandPopup = !expandPopup"
        >
          <div v-if="expandPopup">
            <i class="fas fa-minus mr-1" />
            minimieren
          </div>

          <div v-else>
            <i class="fas fa-plus mr-1" />
            maximieren
          </div>
        </button>
      </div>
      <div v-if="expandPopup">
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <u-loader v-if="isLoading" />
        <div v-else>
          <div class="row">
            <div class="col-05 ml-4 mt-4">
              <label>
                <input
                  v-model="overrideOrder"
                  name="check"
                  type="checkbox"
                >
                <span class="label-text" />
              </label>
            </div>
            <div class="col-3 mt-4 font-weight-bold">
              {{ "Sortierung" }}
            </div>
            <div class="col-8">
              <v-text-field
                v-model="overrideOrderValue"
                :label="'Sortierung'"
                type="number"
                :disabled="!canUserEdit"
              />
            </div>
          </div>
          <div
            v-for="(configEntry, index) in configuration.configEntries"
            :key="index"
            class="row mb-2"
          >
            <template
              v-if="
                (!ruleGroup && configEntry.criteriaStructure) ||
                  (configEntry.criteriaStructure &&
                  groupedRuleConfig &&
                  groupedRuleConfig.groupEntries.filter(
                    (groupedConfigEntry) => {
                      return (
                        groupedConfigEntry.criteriaStructureId ==
                        configEntry.criteriaStructureId
                      );
                    },
                  ).length == 0)
              "
            >
              <div class="col-05 ml-4 mt-4">
                <label>
                  <input
                    :checked="
                      propertiesToSet.filter((property) => {
                        return property.id == configEntry.id;
                      }).length > 0
                    "
                    name="check"
                    type="checkbox"
                    @click="checkBoxValueChanged(configEntry)"
                  >
                  <span class="label-text" />
                </label>
              </div>
              <div class="col-3 font-weight-bold mt-4">
                {{ configEntry.criteriaStructure.name }}
              </div>
              <div class="col-8">
                <rule-criteria-autocomplete
                  v-model="ruleToEditObject"
                  :all-values="ruleToEditObject"
                  :contract-id="contractId"
                  :edition-id="editionId"
                  :structure-item="configEntry"
                  :version-number="versionId"
                  collection-name="entries"
                />
              </div>
            </template>
            <template
              v-if="
                (!ruleGroup && configEntry.criteriaGroup) ||
                  (configEntry.criteriaGroup &&
                  groupedRuleConfig &&
                  groupedRuleConfig.groupEntries.filter(
                    (groupedConfigEntry) => {
                      return (
                        groupedConfigEntry.criteriaGroupId ==
                        configEntry.criteriaGroupId
                      );
                    },
                  ).length == 0)
              "
            >
              <div class="col-05 ml-4 mt-4">
                <label>
                  <input
                    :checked="
                      propertiesToSet.filter((property) => {
                        return property.id == configEntry.id;
                      }).length > 0
                    "
                    name="check"
                    type="checkbox"
                    @click="checkBoxValueChanged(configEntry)"
                  >
                  <span class="label-text" />
                </label>
              </div>
              <div class="col-3 font-weight-bold mt-4">
                {{ configEntry.criteriaGroup.name }}
              </div>
              <div class="col-8">
                <v-select
                  v-if="
                    ruleToEditObject.entries.filter((entry) => {
                      return (
                        entry.criteriaGroupId == configEntry.criteriaGroupId
                      );
                    })[0]
                  "
                  v-model="
                    ruleToEditObject.entries.filter((entry) => {
                      return (
                        entry.criteriaGroupId == configEntry.criteriaGroupId
                      );
                    })[0].value
                  "
                  :items="
                    GetValuesForGroupings(
                      groupings,
                      configEntry.criteriaGroupId,
                    )
                  "
                  item-text="value"
                  item-value="value"
                />
              </div>
            </template>
            <template
              v-if="
                (!ruleGroup && configEntry.variable) ||
                  (configEntry.variable &&
                  groupedRuleConfig &&
                  groupedRuleConfig.groupEntries.filter(
                    (groupedConfigEntry) => {
                      return (
                        groupedConfigEntry.variable == configEntry.variable
                      );
                    },
                  ).length == 0)
              "
            >
              <div class="col-05 ml-4 mt-4">
                <label>
                  <input
                    :checked="
                      propertiesToSet.filter((property) => {
                        return property.id == configEntry.id;
                      }).length > 0
                    "
                    name="check"
                    type="checkbox"
                    @click="checkBoxValueChanged(configEntry)"
                  >
                  <span class="label-text" />
                </label>
              </div>
              <div class="col-3 font-weight-bold mt-4">
                {{ configEntry.variable.name }}
              </div>
              <div class="col-8">
                <div v-if="configEntry.variable.type == 4">
                  <v-select
                    v-model="
                      ruleToEditObject.entries.filter((entry) => {
                        return entry.variableId == configEntry.variableId;
                      })[0].value
                    "
                    :items="flagOptions"
                    item-text="label"
                    item-value="value"
                  />
                </div>
                <div v-else>
                  <v-text-field
                    v-if="
                      ruleToEditObject.entries.filter((entry) => {
                        return entry.variableId == configEntry.variableId;
                      })[0]
                    "
                    v-model="
                      ruleToEditObject.entries.filter((entry) => {
                        return entry.variableId == configEntry.variableId;
                      })[0].value
                    "
                    :label="configEntry.variable.name"
                  />
                </div>
              </div>
            </template>
          </div>

          <b-button
            v-b-tooltip.hover
            class="ml-2"
            placement="bottom"
            title="Die Regeln werden gespeichert und die ausgwählten Eigenschaften überschrieben"
            variant="success"
            @click="saveRules()"
          >
            Speichern
          </b-button>
          <b-button
            v-b-tooltip.hover
            class="ml-2"
            placement="bottom"
            title="Die Regeln werden dupliziert und die ausgwählten Eigenschaften überschrieben"
            variant="success"
            @click="copyRules()"
          >
            Regeln duplizieren
          </b-button>

          <b-button
            class="ml-2"
            variant="danger"
            @click="
              hideModal(
                'bulkEditCopyRule' +
                  uniqueIdentifier +
                  ruleId +
                  (ruleGroup ? 'Grouped' : ''),
              );
              ruleToEdit = null;
            "
          >
            Abbrechen
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  GetGroupedRuleConfiguration,
  UpdateCopyRules,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import { GetValuesForGroupings } from "@/helpers/MinimumWageRulesHelper.js";
import RuleCriteriaAutocomplete from "@/components/minimum.wage/pages/Rules/RuleCriteriaAutocomplete.vue";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    RuleCriteriaAutocomplete,
  },
  mixins: [MinimumWageMixin],
  props: {
    selectedRules: {
      type: Array,
      required: true,
    },
    uniqueIdentifier: {
      type: String,
      required: true,
    },
    ruleGroup: {
      type: Object,
      default() {
        return null;
      },
    },
    editMode: {
      type: Boolean,
      default() {
        return true;
      },
    },
    configuration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      errorObject: null,
      expandPopup: true,
      selected: [],
      isLoading: false,
      groupConfiguration: null,
      groupProperties: [],
      hideSelection: true,
      ruleToEdit: null,
      ruleToEditObject: null,
      GetValuesForGroupings: GetValuesForGroupings,
      groupings: this.$store.state.mindestLohnKonfiguration.Groupings,
      selectedValues: [],
      objectToSave: {},
      newRule: false,
      groupedRuleConfig: null,
      ruleId: 0,
      propertiesToSet: [],
      copy: true,
      flagOptions: [
        { label: "", value: "" },
        { label: "Ja", value: "Y" },
        { label: "Nein", value: "N" },
      ],
      overrideOrder: false,
      overrideOrderValue: null,
    };
  },
  methods: {
    checkBoxValueChanged(configEntry) {
      if (
        this.propertiesToSet.filter((prop) => {
          return prop.id == configEntry.id;
        }).length > 0
      ) {
        var currentIndex = this.propertiesToSet.indexOf(
          this.propertiesToSet.filter((prop) => {
            return prop.id == configEntry.id;
          })[0],
        );
        this.propertiesToSet.splice(currentIndex, 1);
      } else {
        this.propertiesToSet.push(JSON.parse(JSON.stringify(configEntry)));
      }
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    init() {
      this.isLoading = true;

      this.ruleToEditObject = {
        id: 0,
        ruleConfigurationId: this.configuration.id,
        ruleGroupId: this.ruleGroup ? this.ruleGroup.id : null,
        order: 0,
        entries: [],
      };

      this.configuration.configEntries.map((configEntry) => {
        configEntry.selected = false;

        var ruleValueEntry = this.ruleToEditObject.entries.filter((entry) => {
          return (
            (entry.criteriaGroupId &&
              entry.criteriaGroupId == configEntry.criteriaGroupId) ||
            (entry.criteriaStructureId &&
              entry.criteriaStructureId == configEntry.criteriaStructureId) ||
            (entry.variableId && entry.variableId == configEntry.variableId)
          );
        });

        if (ruleValueEntry.length == 0) {
          this.ruleToEditObject.entries.push({
            id: 0,
            ruleId: this.ruleToEditObject.id,
            criteriaStructureId:
              configEntry.criteriaStructureId != 0
                ? configEntry.criteriaStructureId
                : null,
            criteriaGroupId:
              configEntry.criteriaGroupId != 0
                ? configEntry.criteriaGroupId
                : null,
            variableId:
              configEntry.variableId != 0 ? configEntry.variableId : null,
            value: "",
            criteriaListEntryId: null,
          });
        }
      });

      // if there is a ruleGroupId, the rule is grouped
      // this means we need to remove the grouped properties
      if (this.ruleGroup) {
        this.loadGroupedConfiguration();
      } else {
        this.isLoading = false;
      }

      this.newRule = true;
    },
    copyRules() {
      this.copy = true;
      this.processAllRules();
    },
    saveRules() {
      this.copy = false;
      this.processAllRules();
    },
    processAllRules() {
      this.errorObject = null;
      this.isLoading = true;

      var rulesUpdateObject = {
        ruleIds: [],
        entries: [],
        order: null,
      };

      if (this.overrideOrder) {
        rulesUpdateObject.order = this.overrideOrderValue;
      }

      this.selectedRules.map((rule) => {
        rulesUpdateObject.ruleIds.push(rule.id);
      });

      this.ruleToEditObject.entries.map((ruleEntry) => {
        var toBeUpdated =
          this.propertiesToSet.filter((prop) => {
            return (
              (prop.criteriaStructureId != null &&
                prop.criteriaStructureId == ruleEntry.criteriaStructureId) ||
              (prop.variableId != null &&
                prop.variableId == ruleEntry.variableId) ||
              (prop.criteriaGroupId != null &&
                prop.criteriaGroupId == ruleEntry.criteriaGroupId)
            );
          }).length > 0;

        if (toBeUpdated) {
          rulesUpdateObject.entries.push(ruleEntry);
        }
      });

      UpdateCopyRules(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        rulesUpdateObject,
        this.copy,
        () => {
          this.$emit("ruleSaved");
          this.hideModal(
            "bulkEditCopyRule" +
              this.uniqueIdentifier +
              this.ruleId +
              (this.ruleGroup ? "Grouped" : ""),
          );
          this.ruleToEdit = null;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    loadGroupedConfiguration() {
      GetGroupedRuleConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleGroup.id,
        (response) => {
          this.groupedRuleConfig = response;

          response.groupEntries.map((groupEntry) => {
            var propertyToSetFromConfig = this.ruleToEditObject.entries.filter(
              (property) => {
                return groupEntry.criteriaStructureId
                  ? groupEntry.criteriaStructureId ==
                      property.criteriaStructureId
                  : false || groupEntry.criteriaGroupId
                    ? groupEntry.criteriaGroupId == property.criteriaGroupId
                    : false;
              },
            );

            if (propertyToSetFromConfig[0]) {
              propertyToSetFromConfig[0].value = groupEntry.value;
              propertyToSetFromConfig[0].criteriaListEntryId =
                groupEntry.criteriaListEntryId;
            }
          });

          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.menuable__content__active {
  z-index: 6000 !important;
}
</style>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.col-05 {
  -ms-flex: 0 0 2%;
  -webkit-box-flex: 0;
  flex: 0 0 2%;
  max-width: 2%;
}
</style>
